class TilePool {
  constructor (frames, count) {
    // randomly select only a quarter as many frames as we need for the pool
    // this will ensure the 4 tile 2 set match rule
    this.frames = [];
    let randomized = _.shuffle(_.clone(frames));
    if (count % 4 === 0) {
      count += 2;
    }
    while (this.frames.length < count / 4) {
      if (randomized.length === 0) {
        randomized = _.shuffle(_.clone(frames));
      }
      this.frames.push(randomized.pop());
    }

    // console.log('Pool Frames', this.frames);

    this.fillPool();
  }
  fillPool () {
    let tileFrames = [];
    _.each(this.frames, frame => {
      tileFrames.push(frame.filename);
    });
    this.tileFrames = _.shuffle(tileFrames);
  }
  getTileFrame () {
    if (this.tileFrames.length === 0) {
      // console.log('Pool refill');
      this.fillPool();
    }
    return this.tileFrames.pop();
  }
}

class Tile {
  constructor () {
    this.sprite = null;
    this.isActive = false;
    this.id = null;
    this.bearType = null;
    this.collectableType = null;
  }
  setCold () {
    let frameName = this.sprite.frame.name;
    this.sprite.setTexture('tiles-inactive');
    this.sprite.setFrame(frameName);
  }
  setHot () {
    let frameName = this.sprite.frame.name;
    this.sprite.setTexture('tiles-closed');
    this.sprite.setFrame(frameName);
  }
}

export {
  TilePool,
  Tile
};
